import { atom, selector } from "recoil";
import { isCommon, TCommonElementIndex, USE_X_COMMON } from "./useXCommon";
import {
  TUseXElement,
  USE_X_ELEMENT,
  USE_X_ELEMENT_SELECTOR,
} from "./useXElement";

export const USE_SELECTED_INDEX = atom<string | null>({
  key: "USE_SELECTED_INDEX",
  default: null,
});

export const SELECTED_ELEMENT = selector<TUseXElement<any> | null>({
  key: "SELECTED_ELEMENT",
  get: (opts) => {
    const id = opts.get(USE_SELECTED_INDEX);

    if (!id) return null;

    let element: any;

    if (isCommon(id)) {
      element = opts.get(USE_X_COMMON(id as TCommonElementIndex));
    } else {
      element = opts.get(USE_X_ELEMENT(id));
    }

    if (!element || Object.keys(element).length === 0) return null;

    return { ...element, id };
  },
  set: (opts, newValue) => {
    const id: any = opts.get(USE_SELECTED_INDEX);

    const other = document.querySelectorAll("[data-x-selected]");

    if (other.length > 0) {
      other.forEach((e) => e.removeAttribute("data-x-selected"));
    }

    if (id) {
      const target = document.getElementById(id);

      if (target) target.setAttribute("data-x-selected", "true");

      // if (isCommon(id)) {
      return opts.set(USE_X_ELEMENT_SELECTOR(id), newValue);
      // } else {
      //   return opts.set(USE_X_ELEMENT_SELECTOR(id), newValue);
      // }
    }

    return null;
  },
});
